/** @jsxImportSource @emotion/react */

import { AppBar, Background, Positioning, Spacing } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";
import Drawer from "@mui/material/Drawer";
import Box from "@mui/system/Box";
import { useCallback, useEffect } from "react";
import { forceCheck } from "react-lazyload";
import { ZERO_DIGIT } from "../../../../constants/env";
import { useSearchModule } from "../../../hooks/useSearchModule";
import BackIconButton from "../../common/back-icon-button/back-icon-button";
import { Results } from "./Results";
import { SEARCH_INPUT_ID, SearchtInput } from "./SearchInput";

const HEADER_HEIGHT = 65;
export const NO_SCROLL_BODY_CLASS = "no-scroll";

const SearchDrawerMobile = styled(Drawer)({
  "& .MuiDrawer-paper": {
    minHeight: "100vh",
    backgroundColor: Background.default,
    width: "100%",
  },
});

const ResultsContainer = styled(Box)({
  marginTop: HEADER_HEIGHT,
  padding: `${Spacing["2000"]} ${Spacing["1000"]} ${Spacing["6000"]} ${Spacing["1000"]}`,
});

function SearchInputMobile(): JSX.Element {
  const { hide, search, isVisible, results, loading, searchText, clearSearch } = useSearchModule();

  const forceCheckOnScrollCallback = useCallback(function onScroll() {
    forceCheck();
  }, []);

  const onInputChangeCallback = useCallback(
    function onInputChange(event: React.ChangeEvent<HTMLInputElement>) {
      search(event.target?.value);
    },
    [search]
  );

  useEffect(() => {
    if (isVisible) document.getElementById(SEARCH_INPUT_ID)?.focus();

    if (isVisible) {
      document.body.classList.add(NO_SCROLL_BODY_CLASS);
    } else {
      document.body.classList.remove(NO_SCROLL_BODY_CLASS);
    }

    return function removeNoScroll() {
      document.body.classList.remove(NO_SCROLL_BODY_CLASS);
    };
  }, [isVisible]);

  useEffect(() => {
    window.scrollTo({ top: ZERO_DIGIT, left: ZERO_DIGIT });
  }, [results]);

  return (
    <SearchDrawerMobile
      variant="persistent"
      open={isVisible}
      anchor="right"
      elevation={ZERO_DIGIT}
      PaperProps={{
        onScroll: forceCheckOnScrollCallback,
      }}
    >
      <AppBar position={Positioning.fixed}>
        <BackIconButton onClick={hide} />
        <SearchtInput value={searchText} autoFocus resetInput={clearSearch} onChange={onInputChangeCallback} />
      </AppBar>

      <ResultsContainer>
        <Results results={results} loading={loading} searchText={searchText} />
      </ResultsContainer>
    </SearchDrawerMobile>
  );
}

export default SearchInputMobile;
